<template>
  <div id="sms-loader-container">
    <div class="sms-loader">
      <g-loader type="default" />
    </div>
  </div>
</template>

<script setup>
import '@garmin/components-global-web/dist-web/components/GLoader';

</script>

<style lang="scss" scoped>
.sms-loader {
  width: 200px;
  margin: 0 auto;
}
</style>
